/*
SELECT CONCAT([Code], ': ', '"', [Code], '"', ',')
FROM [MuellerHomeowner].[dbo].[AppraisalWorkflowStatuses]
ORDER BY Id
*/

export const AppraisalWorkflowStatusCode = {
  ORDER_SUBMITTED: "ORDER_SUBMITTED",
  UNASSIGNED: "UNASSIGNED",
  AWAITING_FIELD_REPORT: "AWAITING_FIELD_REPORT",
  AVAILABLE_TO_APPRAISER: "AVAILABLE_TO_APPRAISER",
  REJECTED_TO_FIELD: "REJECTED_TO_FIELD",
  APPRAISAL_SUBMITTED: "APPRAISAL_SUBMITTED",
  PENDING_APPRAISAL_QA: "PENDING_APPRAISAL_QA",
  IN_APPRAISAL_QA: "IN_APPRAISAL_QA",
  ASSIGNED_TO_QA_MANAGER: "ASSIGNED_TO_QA_MANAGER",
  REJECTED_TO_APPRAISER: "REJECTED_TO_APPRAISER",
  COMPLETION_PENDING: "COMPLETION_PENDING",
  CUSTOMER_REJECTED: "CUSTOMER_REJECTED",
  COMPLETED: "COMPLETED",
  RECONSIDERATION_PENDING: "RECONSIDERATION_PENDING",
  FIELD_RECONSIDERING: "FIELD_RECONSIDERING",
  APPRAISER_RECONSIDERING: "APPRAISER_RECONSIDERING",
  CANCELLED_PRE_INSPECTION: "CANCELLED_PRE_INSPECTION",
  CLOSED_POST_INSPECTION: "CLOSED_POST_INSPECTION",
  CLOSED_PRE_APPRAISAL: "CLOSED_PRE_APPRAISAL",
  PENDING_APPRAISAL_ASSIGNMENT: "PENDING_APPRAISAL_ASSIGNMENT",
  APPRAISAL_SUBMITTAL_VERIFICATION: "APPRAISAL_SUBMITTAL_VERIFICATION",
  VEROS_PREVIEW_REQUESTED: "VEROS_PREVIEW_REQUESTED",
  VEROS_PREVIEW_RESULT_ERROR: "VEROS_PREVIEW_RESULT_ERROR",
  VEROS_PREVIEW_RESULT_SUCCESS: "VEROS_PREVIEW_RESULT_SUCCESS",
  VEROS_PREVIEW_ERROR_APPRAISER: "VEROS_PREVIEW_ERROR_APPRAISER",
  GAAR_PREVIEW_REQUESTED: "GAAR_PREVIEW_REQUESTED",
  GAAR_PREVIEW_RESULT_ERROR: "GAAR_PREVIEW_RESULT_ERROR",
  GAAR_PREVIEW_RESULT_SUCCESS: "GAAR_PREVIEW_RESULT_SUCCESS",
  GAAR_PREVIEW_ERROR_APPRAISER: "GAAR_PREVIEW_ERROR_APPRAISER",
  UCDP_SUBMITTED_PENDING_RESPONSE: "UCDP_SUBMITTED_PENDING_RESPONSE",
  UCDP_RESULT_RECEIVED_WITH_ERRORS: "UCDP_RESULT_RECEIVED_WITH_ERRORS",
  UCDP_RESULT_RECEIVED_NO_ERRORS: "UCDP_RESULT_RECEIVED_NO_ERRORS",
  SUBMITTING_TO_CUSTOMER: "SUBMITTING_TO_CUSTOMER",
  AWAITING_ELIGIBILITY_DECISION: "AWAITING_ELIGIBILITY_DECISION",
  APPRAISAL_WAIVED: "APPRAISAL_WAIVED",
  ORDER_PAYMENT_REQUIRED: "ORDER_PAYMENT_REQUIRED",
  ORDER_PAYMENT_PENDING: "ORDER_PAYMENT_PENDING",
  ORDER_PAYMENT_EXPIRED: "ORDER_PAYMENT_EXPIRED",
  ORDER_PAYMENT_DECLINED: "ORDER_PAYMENT_DECLINED",
  APPRAISAL_PRODUCT_CONVERSION: "APPRAISAL_PRODUCT_CONVERSION",
  CLOSED_PRE_INSPECTION: "CLOSED_PRE_INSPECTION",
};